import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { FileText, Clock, AlertTriangle, CheckCircle2, XCircle, FileClock } from 'lucide-react';

export function RequestsKpiDashboard() {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng Yêu Cầu',
      value: 125,
      suffix: 'Phiếu',
      icon: FileText,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-indigo-500',
      chartData: [110, 115, 120, 118, 122, 124, 125]
    },
    {
      title: 'Đang Xử Lý',
      value: 35,
      suffix: 'Phiếu',
      icon: Clock,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: 'Đang theo dõi',
      chartColor: 'bg-blue-500',
      chartData: [25, 28, 30, 32, 33, 34, 35]
    },
    {
      title: 'Chờ Phê Duyệt',
      value: 12,
      suffix: 'Phiếu',
      icon: FileClock,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'down',
      trendValue: 'Đã duyệt 5',
      chartColor: 'bg-amber-500',
      chartData: [20, 18, 15, 14, 13, 13, 12]
    },
    {
      title: 'Đã Hoàn Thành',
      value: 75,
      suffix: 'Phiếu',
      icon: CheckCircle2,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Đúng hạn',
      chartColor: 'bg-emerald-500',
      chartData: [60, 65, 68, 70, 72, 74, 75]
    },
    {
      title: 'Quá Hạn',
      value: 5,
      suffix: 'Cảnh báo',
      icon: AlertTriangle,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'up',
      trendValue: 'Cần đốc thúc',
      chartColor: 'bg-rose-500',
      chartData: [2, 3, 3, 4, 4, 5, 5]
    },
    {
      title: 'Bị Từ Chối',
      value: 3,
      suffix: 'Phiếu',
      icon: XCircle,
      color: 'text-red-600',
      bg: 'bg-red-50',
      trend: 'down',
      trendValue: 'Giảm 2',
      chartColor: 'bg-red-500',
      chartData: [6, 5, 5, 4, 4, 3, 3]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
